// extracted by mini-css-extract-plugin
export var sliderRange = "_p1-2";
export var sliderRoot = "_p1-0";
export var sliderThumb = "_p1-3";
export var sliderTrack = "_p1-1";